import { Icon24ErrorCircleOutline, Icon28ErrorCircleOutline } from '@vkontakte/icons';
import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useCallback } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { ButtonLink } from 'reactApp/ui/ButtonLink/ButtonLink';
import opener from 'reactApp/utils/opener';

import styles from './VkMusicRewardInfo.css';

interface VkMusicRewardInfoProps {
    accountLink?: string;
    isMobile?: boolean;
}

export function VkMusicRewardInfo({ accountLink, isMobile }: VkMusicRewardInfoProps) {
    const goToVkMusic = useCallback(() => {
        opener(accountLink);
    }, [accountLink]);

    return (
        <div className={classNames(styles.root, { [styles.rootMobile]: isMobile })}>
            {isMobile ? <Icon28ErrorCircleOutline /> : <Icon24ErrorCircleOutline />}
            <div className={styles.container}>
                <Text className={styles.text}>Продлить подписку или отключить автоплатёж можно в&nbsp;VK&nbsp;Музыке</Text>
                {isMobile ? (
                    <ButtonLink onClick={goToVkMusic} data-name="go-to-vkmusic" primary size="medium" inline fontInherit underline={false}>
                        Перейти в&nbsp;VK&nbsp;Музыку
                    </ButtonLink>
                ) : (
                    <Button
                        disabled={!accountLink}
                        className={styles.button}
                        theme="vk"
                        middle
                        sizeMode={ButtonSizeMode.small}
                        onClick={goToVkMusic}
                        data-name="go-to-vkmusic"
                    >
                        Перейти в&nbsp;VK&nbsp;Музыку
                    </Button>
                )}
            </div>
        </div>
    );
}
